export var palette = {
    border: {
        main: '#E4E4E4',
        dark: '#C1C1C3',
    },
    common: {
        black: '#131416',
        white: '#ffffff',
    },
    background: {
        default: '#fff',
    },
    bg: {
        light: '#F9F9FA',
        main: '#E9EAEC',
    },
    primary: {
        main: '#131416',
        light: '#FEF1DD',
        dark: '#000',
    },
    warning: {
        main: '#D6A36D',
        light: '#ECB983',
        dark: '#3E2104',
    },
    error: {
        main: '#E99292',
        light: '#FFA8A8',
        dark: '#651B1B',
    },
    success: {
        main: '#8CD98C',
        light: '#BFE9D4',
        dark: '#133513',
    },
    info: {
        main: '#7CB8E1',
        light: '#92CEF7',
        dark: '#043152',
    },
    text: {
        primary: '#2E2E2E',
        secondary: '#485059',
        disabled: '#A1A1A1',
        subheading: '#878D97',
    },
};
